﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class DepartmentClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    get(key) {
        return this.client.apiDepartmentsByIdGet(key);
    }
    create(department) {
        return this.client.apiDepartmentsPost(department);
    }
    update(key, department) {
        return this.client.apiDepartmentsByIdPut(key, department);
    }
    delete(keys) {
        return this.client.apiDepartmentsDelete(keys);
    }
    getDepartmentsByCompany(id) {
        return this.client.apiDepartmentsCompanyByIdGet(id);
    }
}
exports.DepartmentClient = DepartmentClient;
//# sourceMappingURL=DepartmentClient.js.map